/*
 * Copyright (c) 2020
 *    Reliant Business Valuation, LLC - http://www.reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyPipe'
})
export class CurrencyPipe implements PipeTransform {
  private DECIMAL_SEPARATOR: string = '.';
  private THOUSANDS_SEPARATOR: string = ',';

  transform(value: number | string, fractionSize: number = 2): string {
    if(value === null || value === 0 || value === '')
      return '0';

    let val = (value || '').toString().split(this.DECIMAL_SEPARATOR);
    val[0] = val[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

    if(val.length > 1){
      if(val[1].length < fractionSize){
        // for (let index = 0; val[1].length < fractionSize; index++) {
        //   val[1] += '0';
        // }
      }
      return val[0] + this.DECIMAL_SEPARATOR + val[1];
    }
    else return val[0];
  }

  parse(value: string, fractionSize: number = 2): any {
    let val = (value || '').split(this.DECIMAL_SEPARATOR);
    val[0] = val[0].replace(new RegExp(this.THOUSANDS_SEPARATOR, 'g'), '');

    if(val.length > 1) {
      let beforeFraction = Number(val[0]);
      let afterFraction =  (val[1]).substr(0, fractionSize);

      return beforeFraction + this.DECIMAL_SEPARATOR + afterFraction;
      //return Number(Number(val[0] + this.DECIMAL_SEPARATOR + val[1]).toFixed(fractionSize));
    }
    else if(val[0] === '-')
      return val[0];
    else return Number(val[0]);
  }
}
